import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { LoginForm } from '../LoginForm';
import { AuthBackLink } from '../layout/AuthBackLink';
import { AuthBrandHeader } from '../layout/AuthBrandHeader';

/**
 * Left panel with login form.
 */
export function LoginLeftPanel() {
  return (
    <div className="w-full lg:w-1/2 flex flex-col bg-white">
      <header className="p-6">
        <AuthBackLink />
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-sm"
        >
          <AuthBrandHeader
            heading="Welcome back"
            subheading="Sign in to continue to your account"
          />

          <LoginForm />

          <p className="text-center text-gray-500 mt-8">
            Don't have an account?{' '}
            <Link
              to="/register"
              className="font-medium text-brand-teal hover:text-brand-blue transition-colors"
            >
              Sign up for free
            </Link>
          </p>
        </motion.div>
      </main>
    </div>
  );
}
